module.exports = __webpack_public_path__ + "img/logo.b2cbb01f.svg";